<template>
  <div>
    <HKLDeleteIcon
      v-if="shouldShow"
      @click="delDoc"
    />
  </div>
</template>

<script>
import HKLDeleteIcon from '@/controls/Icon/HKLDeleteIcon.vue'
import { computed, defineComponent } from '@vue/composition-api'
import lodash from 'lodash'
import { GREEN_OPERATION_DOCUMENT_TYPE } from '../consts'
import { useGreenOperationAssessmentFormStatus } from '../hook'

import { unref } from 'vue-demi'
import { useUpdateGreenCertRecordDocs } from './hook'

export default defineComponent({
  components: {
    HKLDeleteIcon,
  },
  props: {
    record: {
      type: Object,
      default: () => null,
    },
    docType: {
      type: String,
      default: '',
    },
    selectedAssessment: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props) {
    const { isEdit } = useGreenOperationAssessmentFormStatus()
    const { greenCertRecordUsingDocs } = useUpdateGreenCertRecordDocs()
    const isUsingGreenCertDocuments = computed(() => {
      return unref(greenCertRecordUsingDocs)
    })
    const isGreenCertDoc = computed(() => props.docType === GREEN_OPERATION_DOCUMENT_TYPE.GREEN_CERT)
    const idToRemove = computed(() => props.record.raw.id)
    const doc = computed(() => props.record.raw)
    function delDoc () {
      if (unref(isEdit)) {
        const submittedMetadata = lodash.get(unref(props.selectedAssessment), 'submittedMetadata')
        const index = submittedMetadata.documents.findIndex(d => d.id === unref(idToRemove))
        if (index > -1) {
          submittedMetadata.documents.splice(index, 1)
        }
      }
    }
    const shouldShow = computed(() => {
      const unrefDoc = unref(doc)
      const isUsingDocs = unref(isGreenCertDoc) && unref(isUsingGreenCertDocuments).includes(unrefDoc.id)
      return unrefDoc.isInherit && unref(isEdit) && !isUsingDocs
    })
    return {
      isUsingGreenCertDocuments,
      doc,
      shouldShow,
      delDoc,
    }
  },
})
</script>
